module.exports = __webpack_public_path__ + "static/media/uthane_m-45.3c43e444.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/climasense/sigatoka_negra/alternative/uthane_m-45.png
// module id = 1169
// module chunks = 3